// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.product-desc small {
  font-size: 10px;
}

.card-active {
  border: 1px solid #fff;
  background-color: #6D6E71;
  color: #fff !important;
}

.text-yellow {
  color: #E3c750;
  font-size: 19px;
}

.text-green {
  background: #fff;
}

.card-status {
  position: absolute;
  bottom: 25px;
  right: 5px;
}

.start-work__col {
  background-color: #6D6E71;
  border-radius: 6px;
  padding: 10px 5px 5px;
}
.start-work__col .ibox {
  margin-bottom: 0;
}
.start-work__col .car-small-heading {
  font-family: "open-sans";
  font-size: 7px;
  text-transform: uppercase;
  letter-spacing: 0.35px;
  font-weight: bold;
  height: auto;
}
.start-work__cell {
  position: relative;
}
.start-work__cell:hover .start-work__popup {
  display: block;
}
.start-work__cell--active {
  z-index: 9;
}
.start-work__cell:not(:last-child) {
  margin-bottom: 9px;
}
.start-work__cell .product-imitation {
  font-family: open-sans;
  min-height: auto;
  height: auto;
  padding: 0;
  font-size: 14px;
  padding: 16px;
  border-radius: 6px;
}
.start-work__cell .product-imitation .product-desc, .start-work__cell .product-imitation span {
  font-size: 14px;
}
.start-work__cell .product-imitation .product-desc br, .start-work__cell .product-imitation span br {
  display: none;
}
.start-work__cell .product-box {
  border-radius: 6px;
}
.start-work__popup {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: calc(100% + 10px);
  width: 350px;
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  display: none;
  z-index: 99;
  color: #6D6E71;
  min-height: 200px;
}
.start-work__popuprow {
  min-height: inherit;
}
.start-work__popuprow > div {
  padding: 10px;
}
.start-work__popuprow--content {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 200px;
}
.start-work__popuprow--content .title-sm {
  font-weight: 600;
}
.start-work__popuprow--content--title ::ng-deep.feedback-content .title-sm {
  display: none;
}
.start-work__popuprow--content--head ::ng-deep.feedback-content .title-sm {
  color: #fff;
  font-weight: 600;
  font-size: 19px;
}
.start-work__popuprow--content--bgc {
  background-color: #fff;
  background-size: contain;
}
.start-work__popuprow--content--bgc ::ng-deep.feedback-content h2 {
  font-size: 20px;
}
.start-work__popuprow--content--bbg {
  background-color: #bfbfbf !important;
  background-size: contain;
}
.start-work__popuprow--content--bbg ::ng-deep.feedback-content h1 {
  position: absolute;
  top: 50%;
  text-align: center;
  left: 0;
  right: 0;
  transform: translateY(-50%);
}
.start-work__popuprow--content--bbg ::ng-deep.feedback-content .title {
  color: #676a6c !important;
}
.start-work__popuprow--content--cong {
  display: flex;
  align-items: center;
}
.start-work__popuprow--content--cong ::ng-deep.feedback-content p,
.start-work__popuprow--content--cong ::ng-deep.feedback-content h2 {
  margin: 0;
}
.start-work__popuprow--content--cong ::ng-deep.feedback-content .feedback-test_result {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.start-work__popuprow--content--wsu9 ::ng-deep.feedback-content .fs-logo-feedback img {
  width: 150px;
}
.start-work__popuprow--content--wsu9 ::ng-deep.feedback-content .feedback-test_result {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.start-work__popuprow--content--wsu9 ::ng-deep.feedback-content .feedback-test_result .big-profile {
  margin-right: 5px;
}
.start-work__popuprow--content--wn ::ng-deep.feedback-content .title-sm {
  color: #fff;
  float: left;
  background: rgba(243, 243, 243, 0.3) !important;
  min-width: 90px;
  padding: 10px;
}
.start-work__popuprow--content--wwo ::ng-deep.feedback-content .title-sm {
  margin-bottom: 30px !important;
}
.start-work__popuprow--content--wwo ::ng-deep.feedback-content .col-sm-5 {
  padding: 0;
}
.start-work__popuprow--content--wwo ::ng-deep.feedback-content .col-sm-5 .text-center img {
  width: 80px;
}
.start-work__popuprow--content--wwo ::ng-deep.feedback-content .col-sm-5 h3 {
  font-size: 12px;
}
.start-work__popuprow--content--cp ::ng-deep.feedback-content h2 {
  font-size: 17px;
}
.start-work__popuprow--content--cp ::ng-deep.feedback-content .cig_collab_img img {
  width: 200px;
}
.start-work__popuprow--content--cpro ::ng-deep.feedback-content .profile_types {
  margin-inline: auto;
}
.start-work__popuprow--content--cpro ::ng-deep.feedback-content .feedback-test_result {
  text-align: center;
}
.start-work__popuprow--content--cpro ::ng-deep.feedback-content .about-u {
  background-color: #F1F1F2;
  overflow: hidden;
  margin-bottom: 10px;
}
.start-work__popuprow--content--cpro ::ng-deep.feedback-content .fix-label {
  background: #6D6E71;
  color: #fff;
  font-size: 4px;
  padding: 4px;
  font-family: "Museo-700";
  display: inline-block;
  vertical-align: top;
}
.start-work__popuprow--content--cpro ::ng-deep.feedback-content .right-label {
  display: block;
  margin-bottom: 1px;
  text-align: right;
  font-size: 8px;
  color: #fff;
}
.start-work__popuprow--content--cpro ::ng-deep.feedback-content .profile-description {
  font-size: 7px;
}
.start-work__popuprow--content--graph ::ng-deep.feedback-content .title-sm {
  font-size: 18px;
}
.start-work__popuprow--content--graph ::ng-deep.feedback-content .chart-title {
  font-size: 8px;
}
.start-work__popuprow--content--graph ::ng-deep.feedback-content .pointer {
  font-size: 9px;
}
.start-work__popuprow--content--graph ::ng-deep.feedback-content .chart-section .pointer {
  width: 25px;
  height: 25px;
  line-height: 25px;
  margin-bottom: -30px;
}
.start-work__popuprow--content--graph ::ng-deep.feedback-content .chart-section .chart-title {
  right: -5px;
  bottom: -31px;
  width: 60px;
}
.start-work__popuprow--content--graph ::ng-deep.feedback-content .dividers-yxis .chart-title {
  right: -29px;
  width: 56px;
}
.start-work__popuprow--content--graph ::ng-deep.feedback-content .dividers-yxis .chart-title::before {
  border-width: 0 28px 10px 28px;
}
.start-work__popuprow--content--graph ::ng-deep.feedback-content .row.f-score {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 10px;
}
.start-work__popuprow--content--graph ::ng-deep.feedback-content .row.f-score .col-xs-7,
.start-work__popuprow--content--graph ::ng-deep.feedback-content .row.f-score .col-xs-5 {
  float: none;
  padding: 0;
}
.start-work__popuprow--content ::ng-deep.feedback-content .title {
  font-size: 20px;
  color: #fff;
  font-weight: 600;
  margin: 0;
}
.start-work__popuprow--content ::ng-deep.feedback-content .custom-row {
  display: flex;
  flex-wrap: wrap;
}
.start-work__popuprow--content ::ng-deep.feedback-content .custom-row img {
  width: 50px;
}
.start-work__popuprow--content ::ng-deep.feedback-content .custom-row .custom-col {
  width: 23%;
  margin: 1%;
}
.start-work__popuprow--content ::ng-deep.feedback-content .custom-row .custom-col p {
  font-size: 12px;
}
.start-work__popupleft {
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  align-self: center;
}
.start-work__popupleft img {
  max-width: 100%;
}
.start-work__popupvideo {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
}
.start-work__popupvideo iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.start-work__popupright {
  width: 50%;
  color: #6D6E71;
}
.start-work__popupright ul {
  padding-left: 20px;
  display: none;
}
.start-work__popupright li {
  word-break: break-word;
}

::ng-deep.lmslider__ftrplayer {
  color: #000;
  line-height: 0;
}
::ng-deep.lmslider__ftrplayer audio {
  color: #000;
}
.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: -ms-flexbox;
  display: block;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
::ng-deep .wrap-all-boxes {
  display: table;
  margin: 0 auto 50px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .wrap-all-boxes {
    text-align: center;
  }
}

.start-work {
  max-width: 180px;
}
@media only screen and (max-width: 991px) {
  .start-work {
    max-width: unset;
  }
}

@media only screen and (max-width: 991px) {
  .f-col-3 {
    width: 50%;
  }
}
@media only screen and (max-width: 767px) {
  .f-col-3 {
    width: 100%;
  }
}

.tcwa__cardview {
  flex-wrap: nowrap;
}
@media only screen and (max-width: 991px) {
  .tcwa__cardview {
    flex-wrap: wrap;
  }
}

::ng-deep .coach-cards {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}
::ng-deep .coach-cards::before, ::ng-deep .coach-cards::after {
  display: none;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .coach-cards {
    display: block;
  }
}
::ng-deep .coach .start-work {
  max-width: none !important;
}
::ng-deep .coach .start-work__ccol .ibox .single-card-link.product-imitation:hover {
  background: #f2f2f2;
}
::ng-deep .coach .start-work__ccol [class\$=ibox] {
  background: #464646;
}
::ng-deep .coach .start-work__ccol [class\$=ibox] .single-card-link.product-imitation {
  color: #fff;
}
::ng-deep .coach .start-work__ccol [class\$=ibox] .single-card-link.product-imitation:hover {
  background: #262626;
}
::ng-deep .coach .start-work__ccol.clarify .start-work__ccell:first-child .ibox {
  background-color: rgb(0, 173, 208);
  border-radius: 5px;
}
::ng-deep .coach .start-work__ccol.clarify .start-work__ccell:first-child .ibox .product-box .product-imitation {
  color: #fff;
}
::ng-deep .coach .start-work__ccol.clarify .start-work__ccell:first-child .ibox .product-box .product-imitation:hover {
  background: #0098b7;
}
::ng-deep .coach .start-work__ccol.ideate .start-work__ccell:first-child .ibox.ideate {
  background-color: rgb(255, 121, 0);
  border-radius: 5px;
}
::ng-deep .coach .start-work__ccol.ideate .start-work__ccell:first-child .ibox.ideate .product-box .product-imitation {
  color: #fff !important;
}
::ng-deep .coach .start-work__ccol.ideate .start-work__ccell:first-child .ibox.ideate .product-box .product-imitation:hover {
  background: #e66d00;
}
::ng-deep .coach .start-work__ccol.develop .start-work__ccell:first-child .ibox {
  background-color: rgb(105, 190, 40);
  border-radius: 5px;
}
::ng-deep .coach .start-work__ccol.develop .start-work__ccell:first-child .ibox .product-box .product-imitation {
  color: #fff !important;
}
::ng-deep .coach .start-work__ccol.develop .start-work__ccell:first-child .ibox .product-box .product-imitation:hover {
  background: #5da924;
}
::ng-deep .coach .start-work__ccol.implement .start-work__ccell:first-child .ibox {
  background-color: rgb(245, 67, 89);
  border-radius: 5px;
}
::ng-deep .coach .start-work__ccol.implement .start-work__ccell:first-child .ibox .product-box .product-imitation {
  color: #fff !important;
}
::ng-deep .coach .start-work__ccol.implement .start-work__ccell:first-child .ibox .product-box .product-imitation:hover {
  background: #f42b44;
}
::ng-deep .coach .start-work__ccol .arrow-icons {
  padding: 22px 10px;
  border-radius: 5px;
  margin-bottom: 25px;
}
::ng-deep .coach .start-work__ccol .arrow-icons .car-small-heading {
  height: auto;
  margin: 0;
  color: #fff;
  font-size: 22px;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
::ng-deep .coach .start-work__ccell .ibox.clarify {
  border: 1px solid rgb(0, 173, 208);
}
::ng-deep .coach .start-work__ccell .ibox.clarify .product-imitation {
  color: rgb(0, 173, 208);
}
::ng-deep .coach .start-work__ccell .ibox.ideate {
  border: 1px solid rgb(255, 121, 0);
}
::ng-deep .coach .start-work__ccell .ibox.ideate .product-imitation {
  color: rgb(255, 121, 0) !important;
}
::ng-deep .coach .start-work__ccell .ibox.develop {
  border: 1px solid rgb(105, 190, 40);
}
::ng-deep .coach .start-work__ccell .ibox.develop .product-imitation {
  color: rgb(105, 190, 40) !important;
}
::ng-deep .coach .start-work__ccell .ibox.implement {
  border: 1px solid rgb(245, 67, 89);
}
::ng-deep .coach .start-work__ccell .ibox.implement .product-imitation {
  color: rgb(245, 67, 89) !important;
}
::ng-deep .coach .start-work__ccell .ibox .product-box {
  box-shadow: none !important;
}
::ng-deep .coach .start-work__ccell .ibox .product-box .product-imitation {
  height: auto;
  padding: 21px 6px;
  font-size: 19px;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/learner-maps/dynamic-learner-map/dynamic-card/dynamic-card.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AAxYI;EACI,eAAA;AA2YR;;AAxYA;EACC,sBAAA;EACG,yBAAA;EACH,sBAAA;AA2YD;;AAxYA;EACC,cAAA;EACA,eAAA;AA2YD;;AAxYA;EACC,gBAAA;AA2YD;;AAzYA;EACC,kBAAA;EACA,YAAA;EACA,UAAA;AA4YD;;AAvYC;EACC,yBAAA;EACA,kBAAA;EACA,qBAAA;AA0YF;AAxYE;EACC,gBAAA;AA0YH;AAvYE;EACC,wBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;AAyYH;AArYC;EAEC,kBAAA;AAsYF;AAnYE;EACC,cAAA;AAqYH;AAlYE;EACC,UAAA;AAoYH;AAjYE;EACC,kBAAA;AAmYH;AAhYE;EACC,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAkYH;AAhYG;EACC,eAAA;AAkYJ;AAhYI;EACC,aAAA;AAkYL;AA7XE;EACC,kBAAA;AA+XH;AAzXC;EACC,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,uCAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AA2XF;AAzXE;EAEC,mBAAA;AA0XH;AAxXG;EACC,aAAA;AA0XJ;AAvXG;EACC,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,iBAAA;AAyXJ;AAvXI;EACC,gBAAA;AAyXL;AAnXM;EACC,aAAA;AAqXP;AA5WM;EACC,WAAA;EACA,gBAAA;EACA,eAAA;AA8WP;AAxWI;EACC,sBAAA;EACA,wBAAA;AA0WL;AAtWM;EACC,eAAA;AAwWP;AAnWI;EACC,oCAAA;EACA,wBAAA;AAqWL;AAjWM;EACC,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;AAmWP;AAhWM;EACC,yBAAA;AAkWP;AA7VI;EACC,aAAA;EACA,mBAAA;AA+VL;AA3VM;;EAEC,SAAA;AA6VP;AA1VM;EACC,aAAA;EACA,eAAA;EACA,uBAAA;AA4VP;AAjVO;EACC,YAAA;AAmVR;AA/UM;EACC,aAAA;EACA,eAAA;EACA,uBAAA;AAiVP;AA/UO;EACC,iBAAA;AAiVR;AAtUM;EACC,WAAA;EACA,WAAA;EACA,+CAAA;EACA,eAAA;EACA,aAAA;AAwUP;AA9TM;EACC,8BAAA;AAgUP;AA7TM;EACC,UAAA;AA+TP;AA3TQ;EACC,WAAA;AA6TT;AAzTO;EACC,eAAA;AA2TR;AAhTM;EACC,eAAA;AAkTP;AA7SO;EACC,YAAA;AA+SR;AArSM;EACC,mBAAA;AAuSP;AApSM;EACC,kBAAA;AAsSP;AAnSM;EACC,yBAAA;EACA,gBAAA;EACA,mBAAA;AAqSP;AAlSM;EACC,mBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,wBAAA;EACA,qBAAA;EACA,mBAAA;AAoSP;AAjSM;EACC,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AAmSP;AAhSM;EACC,cAAA;AAkSP;AAzRM;EACC,eAAA;AA2RP;AAxRM;EACC,cAAA;AA0RP;AAvRM;EACC,cAAA;AAyRP;AApRO;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;AAsRR;AAnRO;EACC,WAAA;EACA,aAAA;EACA,WAAA;AAqRR;AA/QO;EACC,YAAA;EACA,WAAA;AAiRR;AA/QQ;EACC,8BAAA;AAiRT;AA1QO;EACC,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;AA4QR;AA1QQ;;EAEC,WAAA;EACA,UAAA;AA4QT;AAnQK;EACC,eAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;AAqQN;AAlQK;EACC,aAAA;EACA,eAAA;AAoQN;AAlQM;EACC,WAAA;AAoQP;AAjQM;EACC,UAAA;EACA,UAAA;AAmQP;AAjQO;EACC,eAAA;AAmQR;AA3PE;EACC,UAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AA6PH;AA3PG;EACC,eAAA;AA6PJ;AAzPE;EACC,kBAAA;EACA,WAAA;EACA,sBAAA;AA2PH;AAzPG;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AA2PJ;AAvPE;EACC,UAAA;EACA,cAAA;AAyPH;AAvPG;EACC,kBAAA;EACA,aAAA;AAyPJ;AAtPG;EACC,sBAAA;AAwPJ;;AAlPA;EACC,WAAA;EACA,cAAA;AAqPD;AApPC;EACC,WAAA;AAsPF;AA3ME;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAEA,oBAAA;EACA,cAAA;EAGQ,uBAAA;EAGA,mBAAA;EACR,mBAAA;EACA,aAAA;EACA,cAAA;AA6MJ;;AA1MA;EACI,yCAAA;EACH,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AA6MD;;AA3MA;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AA8MD;;AA1MA;EACC,mCAAA;EACA,UAAA;AA6MD;;AA3MA;EACC,mCAAA;EACA,qBAAA;EACA,UAAA;AA8MD;;AA5MA;EACC,mCAAA;EACA,mBAAA;EACA,UAAA;AA+MD;;AA7MA;EACC,mCAAA;EACA,qBAAA;EACA,UAAA;AAgND;;AA9MA;EACC;IACC,UAAA;EAiNA;EA/MD;IACC,UAAA;EAiNA;EA/MD;IACC,UAAA;EAiNA;AACF;AA7MA;EAEI,cAAA;EACA,mBAAA;AA8MJ;AA5MC;EALD;IAME,kBAAA;EA+MA;AACF;;AA5MA;EACI,gBAAA;AA+MJ;AA7MC;EAHD;IAIE,gBAAA;EAgNA;AACF;;AA3MI;EAFJ;IAGQ,UAAA;EA+MN;AACF;AA7MC;EAND;IAOQ,WAAA;EAgNN;AACF;;AA3MC;EACC,iBAAA;AA8MF;AA5ME;EAHD;IAIE,eAAA;EA+MD;AACF;;AAxMC;EACC,wBAAA;EACA,2DAAA;AA2MF;AAzME;EAEC,aAAA;AA0MH;AAtME;EAVD;IAWE,cAAA;EAyMD;AACF;AArMC;EACC,0BAAA;AAuMF;AAhMI;EACC,mBAAA;AAkML;AA9LG;EACC,mBDhkBW;ACgwBf;AA9LI;EACC,WAAA;AAgML;AA9LK;EACC,mBAAA;AAgMN;AAvLK;EACC,kCDpoBU;ECqoBV,kBAAA;AAyLN;AArLO;EACC,WAAA;AAuLR;AArLQ;EACC,mBAAA;AAuLT;AAxKM;EACC,kCD5pBQ;EC6pBR,kBAAA;AA0KP;AAtKQ;EACC,sBAAA;AAwKT;AAtKS;EACC,mBAAA;AAwKV;AA1JK;EACC,mCDnrBU;ECorBV,kBAAA;AA4JN;AAxJO;EACC,sBAAA;AA0JR;AAxJQ;EACC,mBAAA;AA0JT;AA7IK;EACC,kCDzsBY;EC0sBZ,kBAAA;AA+IN;AA3IO;EACC,sBAAA;AA6IR;AA3IQ;EACC,mBAAA;AA6IT;AAnIG;EACC,kBAAA;EACG,kBAAA;EACH,mBAAA;AAqIJ;AAnII;EACC,YAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,wEAAA;AAqIL;AAzHI;EACC,kCAAA;AA2HL;AAzHK;EACC,uBDzvBU;ACo3BhB;AAtHI;EACC,kCAAA;AAwHL;AAtHK;EACC,kCAAA;AAwHN;AAnHI;EACC,mCAAA;AAqHL;AAnHK;EACC,mCAAA;AAqHN;AAjHI;EACC,kCAAA;AAmHL;AAjHK;EACC,kCAAA;AAmHN;AA/GI;EACC,2BAAA;AAiHL;AA/GK;EACC,YAAA;EACA,iBAAA;EACA,eAAA;EACA,wEAAA;EACA,gBAAA;AAiHN","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../../assets/styles/variables';\n$mq-pc: 'only screen and (max-width: 1200px)';\n$mq-md: 'only screen and (max-width: 991px)';\n$mq-sm: 'only screen and (max-width: 767px)';\n$mq-mobile: 'only screen and (max-width: 480px)';\n\n.product-desc{\n    small{\n        font-size: 10px;\n    }\n}\n.card-active{\n\tborder: 1px solid #fff;\n    background-color: #6D6E71;\n\tcolor: #fff !important;\n}\n \n.text-yellow{\n\tcolor: #E3c750;\n\tfont-size: 19px;\n}\n\n.text-green{\n\tbackground: #fff;\n}\n.card-status {\n\tposition: absolute;\n\tbottom: 25px;\n\tright: 5px;\n}\n\n.start-work {\n\n\t&__col {\n\t\tbackground-color: #6D6E71;\n\t\tborder-radius: 6px;\n\t\tpadding: 10px 5px 5px;\n\n\t\t.ibox {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\t\t.car-small-heading {\n\t\t\tfont-family: \"open-sans\";\n\t\t\tfont-size: 7px;\n\t\t\ttext-transform: uppercase;\n\t\t\tletter-spacing: 0.35px;\n\t\t\tfont-weight: bold;\n\t\t\theight: auto;\n\t\t}\n\t}\n\n\t&__cell {\n\n\t\tposition: relative;\n\t\t\n\n\t\t&:hover .start-work__popup {\n\t\t\tdisplay: block;\n\t\t}\n\n\t\t&--active {\n\t\t\tz-index: 9;\n\t\t}\n\t\t\n\t\t&:not(:last-child) {\n\t\t\tmargin-bottom: 9px;\n\t\t}\n\n\t\t.product-imitation {\n\t\t\tfont-family: open-sans;\n\t\t\tmin-height: auto;\n\t\t\theight: auto;\n\t\t\tpadding: 0;\n\t\t\tfont-size: 14px;\n\t\t\tpadding: 16px;\n\t\t\tborder-radius: 6px;\n\n\t\t\t.product-desc, span {\n\t\t\t\tfont-size: 14px;\n\n\t\t\t\tbr {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.product-box {\n\t\t\tborder-radius: 6px;\n\t\t}\n\t\t\n\t}\n\n\n\t&__popup {\n\t\tposition: absolute;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t\tbottom: calc(100% + 10px);\n\t\twidth: 350px;\n\t\tborder-radius: 6px;\n\t\tbackground-color: #fff;\n\t\tbox-shadow: 0 0 20px rgba(#000 , 0.1);\n\t\tdisplay: none;\n\t\tz-index: 99;\n\t\tcolor: #6D6E71;\n\t\tmin-height: 200px;\n\n\t\t&row {\n\n\t\t\tmin-height: inherit;\n\n\t\t\t& > div {\n\t\t\t\tpadding: 10px;\n\t\t\t}\n\n\t\t\t&--content {\n\t\t\t\tbackground-position: center;\n\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\tbackground-size: cover;\n\t\t\t\tmin-height: 200px;\n\n\t\t\t\t.title-sm {\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t}\n\n\t\t\t\t&--title {\n\t\t\t\t\t::ng-deep.feedback-content {\n\t\t\t\t\t\t\n\t\t\t\t\t\t.title-sm {\n\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&--head {\n\n\t\t\t\t\t::ng-deep.feedback-content {\n\n\t\t\t\t\t\t.title-sm {\n\t\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\t\tfont-size: 19px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t}\n\n\t\t\t\t&--bgc {\n\t\t\t\t\tbackground-color: #fff;\n\t\t\t\t\tbackground-size: contain;\n\n\t\t\t\t\t::ng-deep.feedback-content {\n\t\t\t\t\t\t\n\t\t\t\t\t\th2 {\n\t\t\t\t\t\t\tfont-size: 20px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t&--bbg {\n\t\t\t\t\tbackground-color: #bfbfbf !important;\n\t\t\t\t\tbackground-size: contain;\n\n\t\t\t\t\t::ng-deep.feedback-content {\n\t\t\t\t\t\t\n\t\t\t\t\t\th1 {\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n\t\t\t\t\t\t.title {\n\t\t\t\t\t\t\tcolor: #676a6c !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&--cong {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\n\t\t\t\t\t::ng-deep.feedback-content { \n\t\t\t\t\t\t\n\t\t\t\t\t\tp,\n\t\t\t\t\t\th2 {\n\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.feedback-test_result {\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tflex-wrap: wrap;\n\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&--wsu9 {\n\n\t\t\t\t\t::ng-deep.feedback-content { \n\n\t\t\t\t\t\t.fs-logo-feedback {\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\timg {\n\t\t\t\t\t\t\t\twidth: 150px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.feedback-test_result {\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tflex-wrap: wrap;\n\t\t\t\t\t\t\tjustify-content: center;\n\n\t\t\t\t\t\t\t.big-profile {\n\t\t\t\t\t\t\t\tmargin-right: 5px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t}\n\n\t\t\t\t&--wn {\n\n\t\t\t\t\t::ng-deep.feedback-content { \n\n\t\t\t\t\t\t.title-sm {\n\t\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t\t\tfloat: left;\n\t\t\t\t\t\t\tbackground: rgba(243, 243, 243, 0.3) !important;\n\t\t\t\t\t\t\tmin-width: 90px;\n\t\t\t\t\t\t\tpadding: 10px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t}\n\n\t\t\t\t&--wwo {\n\n\t\t\t\t\t::ng-deep.feedback-content { \n\n\t\t\t\t\t\t.title-sm { \n\t\t\t\t\t\t\tmargin-bottom: 30px !important;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.col-sm-5 {\n\t\t\t\t\t\t\tpadding: 0;\n\n\t\t\t\t\t\t\t.text-center {\n\n\t\t\t\t\t\t\t\timg {\n\t\t\t\t\t\t\t\t\twidth: 80px;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\th3 {\n\t\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t}\n\n\t\t\t\t&--cp {\n\n\t\t\t\t\t::ng-deep.feedback-content { \n\n\t\t\t\t\t\th2 {\n\t\t\t\t\t\t\tfont-size: 17px;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.cig_collab_img {\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\timg {\n\t\t\t\t\t\t\t\twidth: 200px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&--cpro {\n\n\t\t\t\t\t::ng-deep.feedback-content { \n\n\t\t\t\t\t\t.profile_types {\n\t\t\t\t\t\t\tmargin-inline: auto;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.feedback-test_result {\n\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.about-u {\n\t\t\t\t\t\t\tbackground-color: #F1F1F2;\n\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.fix-label{\n\t\t\t\t\t\t\tbackground: #6D6E71;\n\t\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t\t\tfont-size: 4px;\n\t\t\t\t\t\t\tpadding: 4px;\n\t\t\t\t\t\t\tfont-family: \"Museo-700\";\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t\tvertical-align: top;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.right-label {\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\tmargin-bottom: 1px;\n\t\t\t\t\t\t\ttext-align: right;\n\t\t\t\t\t\t\tfont-size: 8px;\n\t\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.profile-description {\n\t\t\t\t\t\t\tfont-size: 7px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t}\n\n\t\t\t\t&--graph {\n\t\t\t\t\t::ng-deep.feedback-content { \n\n\t\t\t\t\t\t.title-sm {\n\t\t\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.chart-title {\n\t\t\t\t\t\t\tfont-size: 8px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n\t\t\t\t\t\t.pointer {\n\t\t\t\t\t\t\tfont-size: 9px;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.chart-section {\n\n\t\t\t\t\t\t\t.pointer {\n\t\t\t\t\t\t\t\twidth: 25px;\n\t\t\t\t\t\t\t\theight: 25px;\n\t\t\t\t\t\t\t\tline-height: 25px;\n\t\t\t\t\t\t\t\tmargin-bottom: -30px;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t.chart-title {\n\t\t\t\t\t\t\t\tright: -5px;\n\t\t\t\t\t\t\t\tbottom: -31px;\n\t\t\t\t\t\t\t\twidth: 60px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n\t\t\t\t\t\t.dividers-yxis {\n\n\t\t\t\t\t\t\t.chart-title {\n\t\t\t\t\t\t\t\tright: -29px;\n\t\t\t\t\t\t\t\twidth: 56px;\n\n\t\t\t\t\t\t\t\t&::before {\n\t\t\t\t\t\t\t\t\tborder-width: 0 28px 10px 28px;\n\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.row {\n\t\t\t\t\t\t\t&.f-score {\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\tflex-wrap: wrap;\n\t\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t\t\tpadding: 10px;\n\n\t\t\t\t\t\t\t\t.col-xs-7,\n\t\t\t\t\t\t\t\t.col-xs-5 {\n\t\t\t\t\t\t\t\t\tfloat: none;\n\t\t\t\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t::ng-deep.feedback-content {\n\n\t\t\t\t\t.title {\n\t\t\t\t\t\tfont-size: 20px;\n\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t}\n\n\t\t\t\t\t.custom-row {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tflex-wrap: wrap;\n\n\t\t\t\t\t\timg {\n\t\t\t\t\t\t\twidth: 50px;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.custom-col{\n\t\t\t\t\t\t\twidth: 23%;\n\t\t\t\t\t\t\tmargin: 1%;\n\n\t\t\t\t\t\t\tp {\n\t\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&left {\n\t\t\twidth: 50%;\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\t\talign-self: center;\n\n\t\t\timg {\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t}\n\n\t\t&video {\n\t\t\tposition: relative;\n\t\t\twidth: 100%;\n\t\t\tpadding-bottom: 56.25%;\n\n\t\t\tiframe {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tleft: 0;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t}\n\n\t\t&right {\n\t\t\twidth: 50%;\n\t\t\tcolor: #6D6E71;\n\n\t\t\tul {\n\t\t\t\tpadding-left: 20px;\n\t\t\t\tdisplay: none;\n\t\t\t}\n\n\t\t\tli {\n\t\t\t\tword-break: break-word;\n\t\t\t}\n\t\t}\n\t}\n}\n\n::ng-deep.lmslider__ftrplayer {\n\tcolor:#000;\n\tline-height: 0;\n\taudio{\n\t\tcolor: #000;\n\t}\n\t// audio::-webkit-media-controls-mute-button {\n\t//   \tdisplay: none;\n\t// \tpointer-events: none;\n\t// \tvisibility: hidden;\n\t// }\n\t// audio::-webkit-media-controls-volume-slider-container{\n\t// \tdisplay: none;\n\t// \tpointer-events: none;\n\t// }\n\t// ::-webkit-slider-thumb{\n\t// \tdisplay: none;\n\t// \tpointer-events: none;\n\n\t// }\n\t// audio::-webkit-media-controls-volume-slider{\n\t// \tdisplay: none;\n\t// \tpointer-events: none;\n\t// }\n\t\n\t// / Removes play-button */\n\taudio::-webkit-media-controls-play-button {\n\t//   display: none;\n\t}\n\taudio::-webkit-media-controls-panel {\n\t//   display: none;\n\t}\n\t\n\t// /* Removes the timeline /\n\taudio::-webkit-media-controls-timeline {\n\t//   display: none !important;\n\t}\n\t\n\t// / Removes the time stamp */\n\taudio::-webkit-media-controls-current-time-display {\n\t//   display: none;\n\t}\n\taudio::-webkit-media-controls-time-remaining-display {\n\t//   display: none;\n\t}\n\t\n  }\n  .loader-container {\n    position: absolute;\n    left: 0;\n    right: 0;\n    text-align: center;\n    top: 0;\n    bottom: 0;\n    background: rgba(236,236,236,.9);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: block;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    z-index: 9999999999;\n    height: 100vh;\n    margin: 0 auto;\n}\n\n.loader-spin{\n    background-color: hsla(0,0%,92.5%,.9);\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tbottom: 0;\n\tright: 0;\n}\n.loader__inner {\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n\n}\n\n#Path_129{\n\tanimation: blink 2s linear infinite;\n\topacity: 0;\n}\n#Path_130{\n\tanimation: blink 2s linear infinite;\n\tanimation-delay: .5s;\n\topacity: 0;\n}\n#Path_132{\n\tanimation: blink 2s linear infinite;\n\tanimation-delay: 1s;\n\topacity: 0;\n}\n#Path_131{\n\tanimation: blink 2s linear infinite;\n\tanimation-delay: 1.5s;\n\topacity: 0;\n}\n@keyframes blink {\n\t0% {\n\t\topacity: 0;\n\t}\n\t50%{\n\t\topacity: 1;\n\t}\n\t100%{\n\t\topacity: 0;\t\n\t}\n\n}\n\n::ng-deep\n.wrap-all-boxes {\n    display: table;\n    margin: 0 auto 50px;\n\n\t@media only screen  and (max-width:767px) {\n\t\ttext-align: center;\n\t}\n}\n\n.start-work {\n    max-width: 180px;\n\n\t@media only screen  and (max-width:991px) {\n\t\tmax-width: unset;\n\t}\n}\n\n.f-col-3 {\n\n    @media only screen  and (max-width:991px) {\n        width: 50%;\n    }\n\n\t@media only screen  and (max-width:767px) {\n        width: 100%;\n    }\n}\n\n.tcwa {\n\n\t&__cardview {\n\t\tflex-wrap: nowrap;\n\n\t\t@media only screen  and (max-width:991px) {\n\t\t\tflex-wrap: wrap;\n\t\t}\n\t}\n}\n\n::ng-deep \n.coach {\n\n\t&-cards {\n\t\tdisplay: grid !important;\n\t\tgrid-template-columns: repeat(auto-fit , minmax(200px , 1fr) );\n\n\t\t&::before,\n\t\t&::after {\n\t\t\tdisplay: none;\n\t\t}\n\t\t\n\n\t\t@media #{$mq-sm}{ \n\t\t\tdisplay: block;\n\t\t}\n\t}\n\t\n\t \n\t.start-work {\n\t\tmax-width: none !important;\n\n\t\t\n\n\t\t&__ccol {\n\n\t\t\t.ibox{\n\t\t\t\t.single-card-link.product-imitation:hover{\n\t\t\t\t\tbackground: darken(#fff, 5%)\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t[class$=\"ibox\"]{\n\t\t\t\tbackground: $fs-dark-grey;\n\t\t\t\t\n\t\t\t\t.single-card-link.product-imitation{\n\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t\n\t\t\t\t\t&:hover{\n\t\t\t\t\t\tbackground: darken($fs-sidenav-bg, 5%);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.clarify {\n\n\t\t\t\t.start-work__ccell:first-child {\n\t\t\t\t\t\n\t\t\t\t\t.ibox {\n\t\t\t\t\t\tbackground-color: $clarify-color;\n\t\t\t\t\t\tborder-radius: 5px;\n\n\t\t\t\t\t\t.product-box {\n\n\t\t\t\t\t\t\t.product-imitation {\n\t\t\t\t\t\t\t\tcolor: #fff;\n\n\t\t\t\t\t\t\t\t&:hover{\n\t\t\t\t\t\t\t\t\tbackground: darken($clarify-color, 5%);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.ideate {\n\n\t\t\t\t.start-work__ccell {\n\n\t\t\t\t\t&:first-child {\n\n\t\t\t\t\t\t.ibox.ideate {\n\t\t\t\t\t\t\tbackground-color: $ideate-color;\n\t\t\t\t\t\t\tborder-radius: 5px;\n\t\n\t\t\t\t\t\t\t.product-box {\n\t\n\t\t\t\t\t\t\t\t.product-imitation {\n\t\t\t\t\t\t\t\t\tcolor: #fff !important;\n\n\t\t\t\t\t\t\t\t\t&:hover{\n\t\t\t\t\t\t\t\t\t\tbackground: darken($ideate-color, 5%);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.develop {\n\n\t\t\t\t.start-work__ccell:first-child {\n\t\t\t\t\t.ibox {\n\t\t\t\t\t\tbackground-color: $develop-color;\n\t\t\t\t\t\tborder-radius: 5px;\n\n\t\t\t\t\t\t.product-box {\n\n\t\t\t\t\t\t\t.product-imitation {\n\t\t\t\t\t\t\t\tcolor: #fff !important;\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t&:hover{\n\t\t\t\t\t\t\t\t\tbackground: darken($develop-color, 5%);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t}\n\n\t\t\t&.implement {\n\n\t\t\t\t.start-work__ccell:first-child {\n\t\t\t\t\t.ibox {\n\t\t\t\t\t\tbackground-color: $implement-color;\n\t\t\t\t\t\tborder-radius: 5px;\n\n\t\t\t\t\t\t.product-box {\n\n\t\t\t\t\t\t\t.product-imitation {\n\t\t\t\t\t\t\t\tcolor: #fff !important;\n\n\t\t\t\t\t\t\t\t&:hover{\n\t\t\t\t\t\t\t\t\tbackground: darken($implement-color, 5%);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t}\n\n\t\t\t.arrow-icons {\n\t\t\t\tpadding: 22px 10px;\n    \t\t\tborder-radius: 5px;\n\t\t\t\tmargin-bottom: 25px;\n\n\t\t\t\t.car-small-heading {\n\t\t\t\t\theight: auto;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tcolor: #fff;\n\t\t\t\t\tfont-size: 22px;\n\t\t\t\t\tfont-family:  'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n\t\t\t\t}\n\n\t\t\t}\n\n\t\t\t\n\t\t}\n\n\t\t&__ccell {\n\n\t\t\t.ibox {\n\n\t\t\t\t&.clarify {\n\t\t\t\t\tborder: 1px solid $clarify-color;\n\n\t\t\t\t\t.product-imitation {\n\t\t\t\t\t\tcolor: $clarify-color;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\n\t\t\t\t&.ideate {\n\t\t\t\t\tborder: 1px solid $ideate-color;\n\n\t\t\t\t\t.product-imitation {\n\t\t\t\t\t\tcolor: $ideate-color !important;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t}\n\n\t\t\t\t&.develop {\n\t\t\t\t\tborder: 1px solid $develop-color;\n\n\t\t\t\t\t.product-imitation {\n\t\t\t\t\t\tcolor: $develop-color !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&.implement {\n\t\t\t\t\tborder: 1px solid $implement-color;\n\n\t\t\t\t\t.product-imitation {\n\t\t\t\t\t\tcolor: $implement-color !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t.product-box {\n\t\t\t\t\tbox-shadow: none !important;\n\n\t\t\t\t\t.product-imitation {\n\t\t\t\t\t\theight: auto;\n\t\t\t\t\t\tpadding: 21px 6px;\n\t\t\t\t\t\tfont-size: 19px;\n\t\t\t\t\t\tfont-family:  'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
